import { withI18n } from 'react-i18next';
import EmailInvoiceCard from './EmailInvoiceCard';

export const pureComponent = EmailInvoiceCard;
export default withI18n()(EmailInvoiceCard);
